import React, { useState } from 'react';
import { useCart } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';
import './Checkout.css';

const WHATSAPP_NUMBER = '+919289233502'; // replace with your number

function Checkout() {
  const { cartItems, subtotal, deliveryCharge, total, clearCart } = useCart();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '', phone: '', address: '', city: '', pincode: '',
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = 'Name is required';
    if (!form.phone.trim() || !/^\d{10}$/.test(form.phone)) newErrors.phone = 'Enter a valid 10-digit number';
    if (!form.address.trim()) newErrors.address = 'Address is required';
    if (!form.city.trim()) newErrors.city = 'City is required';
    if (!form.pincode.trim() || !/^\d{6}$/.test(form.pincode)) newErrors.pincode = 'Enter a valid 6-digit pincode';
    return newErrors;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handlePlaceOrder = () => {
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const itemLines = cartItems
      .map((item) => `• ${item.name} x${item.quantity} = ₹${item.price * item.quantity}`)
      .join('\n');

    const message =
      `Hello Saundarryam! I'd like to place an order:\n\n` +
      `Items:\n${itemLines}\n\n` +
      `Subtotal: ₹${subtotal}\n` +
      `Delivery: ${deliveryCharge === 0 ? 'Free' : `₹${deliveryCharge}`}\n` +
      `Total: ₹${total}\n\n` +
      `Delivery Details:\n` +
      `Name: ${form.name}\n` +
      `Phone: ${form.phone}\n` +
      `Address: ${form.address}, ${form.city} - ${form.pincode}`;

    const encoded = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, '')}?text=${encoded}`;

    clearCart();
    window.open(whatsappUrl, '_blank');
    navigate('/');
  };

  if (cartItems.length === 0) {
    return (
      <div className="checkout__empty">
        <h2>Nothing to checkout</h2>
        <button onClick={() => navigate('/')}>Browse Soaps</button>
      </div>
    );
  }

  return (
    <div className="checkout">
      <h1>Checkout</h1>
      <div className="checkout__layout">

        <div className="checkout__form-section">
          <h2>Delivery Details</h2>
          <div className="checkout__form">
            <div className="checkout__field">
              <label>Full Name</label>
              <input name="name" value={form.name} onChange={handleChange} placeholder="Your full name" />
              {errors.name && <span className="checkout__error">{errors.name}</span>}
            </div>
            <div className="checkout__field">
              <label>Phone Number</label>
              <input name="phone" value={form.phone} onChange={handleChange} placeholder="10-digit mobile number" maxLength={10} />
              {errors.phone && <span className="checkout__error">{errors.phone}</span>}
            </div>
            <div className="checkout__field">
              <label>Full Address</label>
              <textarea name="address" value={form.address} onChange={handleChange} placeholder="House no, street, area" rows={3} />
              {errors.address && <span className="checkout__error">{errors.address}</span>}
            </div>
            <div className="checkout__field-row">
              <div className="checkout__field">
                <label>City</label>
                <input name="city" value={form.city} onChange={handleChange} placeholder="City" />
                {errors.city && <span className="checkout__error">{errors.city}</span>}
              </div>
              <div className="checkout__field">
                <label>Pincode</label>
                <input name="pincode" value={form.pincode} onChange={handleChange} placeholder="6-digit pincode" maxLength={6} />
                {errors.pincode && <span className="checkout__error">{errors.pincode}</span>}
              </div>
            </div>
          </div>
        </div>

        <div className="checkout__summary">
          <h2>Order Summary</h2>
          <div className="checkout__items">
            {cartItems.map((item) => (
              <div className="checkout__item" key={item.id}>
                <span>{item.name} x{item.quantity}</span>
                <span>₹{item.price * item.quantity}</span>
              </div>
            ))}
          </div>
          <div className="checkout__summary-row">
            <span>Subtotal</span>
            <span>₹{subtotal}</span>
          </div>
          <div className="checkout__summary-row">
            <span>Delivery</span>
            <span>{deliveryCharge === 0 ? 'Free' : `₹${deliveryCharge}`}</span>
          </div>
          <div className="checkout__summary-row checkout__summary-total">
            <span>Total</span>
            <span>₹{total}</span>
          </div>

          <button className="checkout__whatsapp-btn" onClick={handlePlaceOrder}>
            Place Order on WhatsApp
          </button>
          <p className="checkout__note">
            You'll be redirected to WhatsApp with your order details. We'll confirm and share payment info there.
          </p>
        </div>

      </div>
    </div>
  );
}

export default Checkout;